import { render, staticRenderFns } from "./lp-button.vue?vue&type=template&id=4755a3a3&"
import script from "./lp-button.vue?vue&type=script&lang=js&"
export * from "./lp-button.vue?vue&type=script&lang=js&"
import style0 from "./lp-button.vue?vue&type=style&index=0&id=4755a3a3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports